import SuperAdminMetaversesComponent from "./SuperAdminMetaverseDetails.container";

export default SuperAdminMetaversesComponent;
